import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';
import { Formik, Form as FormikForm } from 'formik';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';
import StepTab from 'components/new_ui/Tabs/StepTab';
import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import SubmitButton from 'components/Widgets/SubmitButton';
import Import from 'components/Managers/Members/Views/File/Import/Index';
import { useContext } from 'components/Managers/Members/Context';

export default function Index() {
  const { dispatch } = useContext();
  const [members, setMembers] = useState(null);
  const [loading, setLoading] = useState(false);

  const worker = new Worker(URL.createObjectURL(new Blob([`\
    importScripts("https://cdn.sheetjs.com/xlsx-0.20.1/package/dist/xlsx.full.min.js");

    self.addEventListener('message', (e) => {
      try {
        const file = new FileReaderSync().readAsArrayBuffer(e.data.file);

        const workbook = XLSX.read(file, { cellDates: true });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, { blankrows: false });

        postMessage({ fileData: jsonData });
      } catch(e) {
        postMessage({html: String(e.message || e).bold() });
      }
    }, false);
  `])));

  const parseDate = (date) => {
    if (!date) {
      return null;
    }

    const regex = /^\d{2}(\.|\/)\d{2}(\.|\/)\d{4}$/;
    const stringDate = date.toLocaleDateString?.('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
                       || date.toString();

    if (regex.test(stringDate)) {
      return new Date(date).toString();
    }

    return 'invalid';
  };

  worker.onmessage = (e) => {
    setMembers(e.data.fileData.map((member) => {
      const id = member['Work Email']?.toLowerCase();
      const email = member['Work Email']?.toLowerCase();
      const birthDate = parseDate(member['Date of Birth']);
      const hireDate = parseDate(member['Continuous Service Hire Date']);
      const terminationDate = parseDate(member['Termination Date']);

      return {
        ...member,
        id,
        email,
        'Work Email': email,
        'Date of Birth': birthDate,
        'Continuous Service Hire Date': hireDate,
        'Termination Date': terminationDate,
      };
    }));
    setLoading(false);
  };

  const onSubmit = (values, { _setSubmitting, _setErrors }) => {
    setLoading(true);
    worker.postMessage({ file: values.membersFile });
    dispatch({ type: 'SET_FILE_NAME', fileName: values.membersFile.name });
  };

  if (members !== null) {
    return <Import members={members} />;
  }

  return (
    <>
      <StepTab total={3} current={1} />

      <div className="content">
        <section>
          <h1 className="mb-3">Choose a file from your computer</h1>

          <p>
            Please upload your file using the LeggUP template.
            <br />
            If you don&apos;t have the file ready, you can download our template
            {' '}
            <ExternalLink
              href="/files/leggup_member_file_upload.zip"
              variant={null}
            >
              here
            </ExternalLink>
            .
          </p>
        </section>

        <Formik
          initialValues={{
            membersFile: null,
          }}
          onSubmit={onSubmit}
        >
          {({ values }) => (
            <FormikForm className="needs-validation" noValidate="">
              <section>
                <Row>
                  <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
                    <HorizontalFileField
                      name="membersFile"
                      fileTypes={['XLSX']}
                      showPreview={false}
                      disabled={loading}
                    />
                  </Col>
                </Row>
              </section>

              <footer className="d-flex d-sm-block justify-content-between">
                <Link
                  to={routes.managers.members.index}
                  className="btn btn-outline-primary"
                >
                  Cancel
                </Link>

                <SubmitButton loading={loading} disabled={values.membersFile === null}>
                  Upload
                </SubmitButton>
              </footer>
            </FormikForm>
          )}
        </Formik>
      </div>
    </>
  );
}
